import mapStyleDeepBlue from '@/map/custom_map_config.json'

export const THEME_DEEP_BLUE = 'deep-blue'
export const THEME_AZURE = 'azure'

export const THEME_OPTIONS = [
  { value: THEME_DEEP_BLUE, label: '深蓝' },
  { value: THEME_AZURE, label: '蔚蓝' }
]

/** 百度底图与区划填色：蔚蓝与深蓝共用同一套 */
const MAP_DISTRICT_STYLE = {
  selectedColor: '#00e5ff',
  pickedFill: '#1a6bb8',
  defaultFill: '#123d6e',
  fillOpacitySelected: 0.5,
  fillOpacityDefault: 0.38,
  strokeColor: '#5e9fff',
  strokeWeight: 2,
  labelPinFill: '#03bdca'
}

export const MAP_STYLE_BY_THEME = {
  [THEME_DEEP_BLUE]: mapStyleDeepBlue,
  [THEME_AZURE]: mapStyleDeepBlue
}

export const DISTRICT_FILL_STYLE_BY_THEME = {
  [THEME_DEEP_BLUE]: { ...MAP_DISTRICT_STYLE },
  [THEME_AZURE]: { ...MAP_DISTRICT_STYLE }
}

/** 图表配色（蔚蓝偏青蓝；环图底轨/进度弧带透明度以透出地图） */
export const CHART_STYLE_BY_THEME = {
  [THEME_DEEP_BLUE]: {
    barGradient: ['#5c52c3', '#6cd1f4'],
    gaugeGradient: [
      'rgba(62, 130, 228, 0.88)',
      'rgba(100, 168, 247, 0.82)',
      'rgba(52, 152, 219, 0.88)'
    ],
    gaugeTrack: 'rgba(224, 224, 224, 0.42)',
    gaugeText: '#1ed3e5',
    lineColors: ['#64a8f7', '#5c52c3']
  },
  [THEME_AZURE]: {
    barGradient: ['#3a7bd5', '#5ac9f8'],
    gaugeGradient: [
      'rgba(45, 143, 212, 0.88)',
      'rgba(90, 201, 248, 0.82)',
      'rgba(126, 200, 255, 0.88)'
    ],
    gaugeTrack: 'rgba(200, 220, 235, 0.4)',
    gaugeText: '#5ee7ff',
    lineColors: ['#5ac9f8', '#3a7bd5']
  }
}

export function normalizeThemeId (id) {
  return id === THEME_AZURE ? THEME_AZURE : THEME_DEEP_BLUE
}

export function getChartStyle (themeId) {
  const id = normalizeThemeId(themeId)
  return CHART_STYLE_BY_THEME[id] || CHART_STYLE_BY_THEME[THEME_DEEP_BLUE]
}
